import React, { memo, useCallback } from 'react';

// Componente para campos de nota
const NoteField = memo(({ question }) => {
  return (
    <div className="note-field">
      <div 
        style={{
          padding: '12px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          fontStyle: 'italic',
          color: '#495057'
        }}
      >
        {question.label}
      </div>
    </div>
  );
});

// Componente para campos de código de barras
const BarcodeField = memo(({ question, value, onChange, error, readonly }) => {
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);
  }, [onChange]);

  const handleScanClick = useCallback(() => {
    // Aquí iría la lógica del escáner
    // console.log('Abrir escáner de código de barras');
  }, []);

  return (
    <div className="barcode-field">
      <input
        type="text"
        id={question.name}
        value={value || ''}
        onChange={handleChange}
        placeholder={question.hint || 'Escanee o ingrese código de barras'}
        required={question.required}
        className={error ? 'has-error' : ''}
        readOnly={readonly}
      />
      <button
        type="button"
        onClick={handleScanClick}
        className="barcode-scan-btn"
        disabled={readonly}
      >
        📷 Escanear
      </button>
    </div>
  );
});

NoteField.displayName = 'NoteField';
BarcodeField.displayName = 'BarcodeField';

export {
  NoteField,
  BarcodeField
};